<h1 mat-dialog-title>Configura los multiplicadores para esta fase</h1>

<mat-dialog-content>
  <div class="row mt-3">
    @for (ppttas of company_product_phase_task_time_autocalc_settings; track ppttas) {
      <div class="col-4 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>
            <mat-icon>{{ ppttas.company_product_phase_task_time_autocalc_setting_category.google_fonts_icon_slug }}</mat-icon>
            {{ ppttas.company_product_phase_task_time_autocalc_setting_category.name }}
          </mat-label>
          <input
            matInput
            type="number"
            [ngModel]="ppttas.prcnt"
            [disabled]="!ppttas.company_product_phase_task_time_autocalc_setting_category.is_editable"
            (ngModelChange)="ppttas.prcnt = $event; calculateExample()"
            class="no-spinner"
          />
          <span matSuffix style="margin-right: 5px">%</span>
          <mat-hint>{{ ppttas.value | secondsToStringTime }}</mat-hint>
        </mat-form-field>
      </div>
    }
  </div>
  <div class="row">
    <div class="col-12">
      <p>Desarrollo (1ª col): tiempo base + % de tiempo muerto, documentación y testing.</p>
      <p>Diseño de producto (2ª col): (tiempo base + % de tiempo muerto y documentación) * % de diseño</p>
      <p>Revisión de tarea (3ª col): se calcula sobre el total anterior (seguimiento + diseño) * de rev %.</p>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="accent" (click)="close()">Cancelar</button>
  <button mat-flat-button color="accent" (click)="submit()">Actualizar</button>
</mat-dialog-actions>
